import script from "./product.vue?vue&type=script&setup=true&lang=js"
export * from "./product.vue?vue&type=script&setup=true&lang=js"

import "./product.vue?vue&type=style&index=0&id=0ab7620f&lang=less"

const __exports__ = script;

export default __exports__